module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-BoldItalic-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-BoldItalic-webfont.eot
// module id = 373
// module chunks = 0